import type { VariantLoadingSizeProps } from '../const';
import { cn } from '@utils';
import { forwardRef } from 'react';
import { generateArray, getAnimationDelay, getSizeClass, SR_LOADING_TEXT } from '../helper';
import '../index.less';

function WaveLoading({ className, size = 'md' }: VariantLoadingSizeProps, ref: React.Ref<HTMLDivElement>) {
  const barCount = 5;
  const heights =
    size === 'sm' ? [6, 9, 12, 9, 6] : size === 'lg' ? [10, 15, 20, 15, 10] : [8, 12, 16, 12, 8];

  return (
    <div ref={ref} className={cn('wg-variant-loading__wave-container', getSizeClass(size), className)}>
      {generateArray(barCount).map(i => (
        <div
          key={i}
          className={cn('wg-variant-loading__wave-bar', getSizeClass(size))}
          style={{
            animationDelay: `${getAnimationDelay(i, 'wave')}ms`,
            height: `${heights[i]}px`,
          }}
        />
      ))}
      <span className="wg-variant-loading__sr-only">{SR_LOADING_TEXT}</span>
    </div>
  );
}

const WaveLoadingComponent = forwardRef<HTMLDivElement, VariantLoadingSizeProps>(WaveLoading);
WaveLoadingComponent.displayName = 'WaveLoading';

export default WaveLoadingComponent;
